<template>
  <section class="view-content">
    <b-overlay :show="loading" rounded="sm">
      <div v-if="!opened && !error">
        <b-card class="mt-2 card-message">
          <template v-slot:header>&nbsp;</template>
          <b-skeleton></b-skeleton>
          <b-skeleton></b-skeleton>
          <b-card-footer> &nbsp; </b-card-footer>
        </b-card>
      </div>
      <div v-if="opened" style="position: relative">
        <div class="text-center" v-if="showNewMessages">
          <b-button class="no-border" @click="showConversation">
            <i class="fal fa-chevron-double-up"></i> &nbsp;
            {{ responses_after }} {{ $t("CONVERSATION_NEW_MESSAGES") }}
          </b-button>
        </div>

        <b-alert
          v-if="!functionbox_uuid && showArchived"
          show
          variant="secondary"
          class="mb-2"
          >{{ $t("CLOSED_CONVERSATION") }}
        </b-alert>

        <b-alert
          v-if="functionbox_uuid && showArchived"
          show
          variant="secondary"
          class="mb-2"
          >{{ $t("CLOSED_ISSUE") }}
        </b-alert>

        <b-alert
          v-if="
            functionbox_uuid &&
            claimedBy &&
            claimedBy.email == user.information.email
          "
          show
          variant="warning"
          >{{ $t("CLAIMED_BY") }} {{ $t('ME') }}</b-alert
        >
        <b-alert
          v-if="
            functionbox_uuid &&
            claimedBy &&
            claimedBy.email != user.information.email
          "
          show
          variant="warning"
          >{{ $t("CLAIMED_BY") }} {{ claimedBy.email }}</b-alert
        >
        <div class="no-print">
          <b-button
            v-if="showCloseBtn"
            size="sm"
            @click="closeMessage"
            class="no-border"
          >
            <i class="fal fa-times"></i
            ><span class="hidden-mobile">&nbsp;{{ $t("CLOSE") }}</span>
          </b-button>

          <b-button
            v-if="isConversation"
            size="sm"
            @click="gotoMessage"
            class="no-border"
          >
            {{ $t("GOTO_MESSAGE") }}
          </b-button>

          <b-button
            @click="getInformation"
            class="no-border"
            size="sm"
            v-if="!isConversation"
          >
            <i class="fal fa-sync"></i
            ><span class="hidden-mobile">&nbsp;{{ $t("UPDATE") }}</span>
          </b-button>

          <AddMessageReply
            v-if="showComplete"
            @sentMessage="sentMessage"
            :message="message"
            :functionbox_uuid="functionbox_uuid"
            :external_system_participants="external_system_participants"
            reply-complete
            :user_uuid="user_uuid"
            ><b-button size="sm" class="no-border"
              ><i class="fal fa-reply"></i
              ><span class="hidden-mobile"
                >&nbsp;{{ $t("COMPLETE") }}</span
              ></b-button
            ></AddMessageReply
          >
          <AddMessageReply
            v-if="showRespond"
            @sentMessage="sentMessage"
            :message="message"
            :functionbox_uuid="functionbox_uuid"
            :external_system_participants="external_system_participants"
            :user_uuid="user_uuid"
            ><b-button size="sm" class="no-border"
              ><i class="fal fa-reply"></i
              ><span class="hidden-mobile"
                >&nbsp;{{ $t("RESPOND") }}</span
              ></b-button
            ></AddMessageReply
          >

          <AddMessageReply
            v-if="showRespondAll"
            @sentMessage="sentMessage"
            :message="message"
            reply-all
            :functionbox_uuid="functionbox_uuid"
            :external_system_participants="external_system_participants"
            :user_uuid="user_uuid"
            ><b-button size="sm" class="no-border"
              ><i class="fal fa-reply-all"></i
              ><span class="hidden-mobile"
                >&nbsp;{{ $t("RESPOND_ALL") }}</span
              ></b-button
            ></AddMessageReply
          >

          <AddMessageForward
            v-if="showForward"
            @sentMessage="sentMessage"
            :message="message"
            :functionbox_uuid="functionbox_uuid"
            :user_uuid="user_uuid"
            ><i class="fal fa-share"></i
              ><span class="hidden-mobile"
                >&nbsp;{{ $t("FORWARD") }}</span
              ></AddMessageForward
          >

          <b-dropdown
            size="sm"
            id="dropdown-1"
            :text="$t('MANAGE')"
            class=""
            toggle-class="no-border"
            v-if="message && !isConversation"
          >
            <b-dropdown-item
              v-if="
                functionbox_uuid &&
                showClaim &&
                !showArchived &&
                !functionBoxIsCreator
                && IsMessage(message.message_type)
              "
              @click="claim"
              >{{ $t("CLAIM") }}</b-dropdown-item
            >
            <b-dropdown-item
              v-if="
                functionbox_uuid &&
                showRemoveClaim &&
                !showArchived &&
                !functionBoxIsCreator
                && IsMessage(message.message_type)
              "
              @click="noClaim"
              >{{ $t("REMOVE_CLAIM") }}</b-dropdown-item
            >

            <span v-if="checkValidVersion('4.2.0')">
            <b-dropdown-item
              v-if="!functionbox_uuid && !showArchived && IsMessage(message.message_type)"
              @click="archive"
              >{{ $t("CLOSE_CONVERSATION") }}</b-dropdown-item
            >
            </span>

            <span v-if="!checkValidVersion('4.2.0')">
              <b-dropdown-item
                v-if="!functionbox_uuid && !showArchived && IsMessage(message.message_type)"
                @click="archive"
                >{{ $t("REOPEN_CONVERSATION") }}</b-dropdown-item
              >
              </span>
              <b-dropdown-item
              v-if="!functionbox_uuid && showArchived && IsMessage(message.message_type)"
              @click="noArchive"
              >{{ $t("REOPEN_CONVERSATION") }}</b-dropdown-item
            >

            <b-dropdown-item
              v-if="functionbox_uuid && !showArchived && !functionBoxIsCreator && IsMessage(message.message_type)"
              @click="closeIssue"
              >{{ $t("CLOSE_ISSUE") }}</b-dropdown-item
            >
            <b-dropdown-item
              v-if="functionbox_uuid && showArchived && !functionBoxIsCreator && IsMessage(message.message_type)"
              @click="noArchive"
              >{{ $t("OPEN_ISSUE") }}</b-dropdown-item
            >

            <b-dropdown-divider v-if="IsMessage(message.message_type)"></b-dropdown-divider>

            <b-dropdown-item
              :href="direktLink"
              class="no-border"
              target="_blank"
            >
              {{ $t("OPEN_NEW_TAB") }}
            </b-dropdown-item>

            <b-dropdown-item @click="printBtn">
              {{ $t("PRINT") }}
            </b-dropdown-item>
            <b-dropdown-divider
              v-if="functionbox_uuid && canRemove"
            ></b-dropdown-divider>
            <b-dropdown-item v-if="canRemove" @click="removeMessage">
              {{ $t("DELETE") }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
        <div id="printMe">
          <b-card class="mt-2 card-message" ref="printBody">
            <template v-slot:header v-if="!isConversation">
              <div>
                <img class="icon mr-2" :src="iconImage" /> {{ message.subject }}
              </div>
            </template>
            <UserInfo
              class="mt-2"
              image="/img/default-avatar.png"
              :primary="createdName"
              :secondary="message.creator.email"
              :optional="createdTime"
            ></UserInfo>
            <small v-if="functionBoxCreatedBy != ''"
              >{{ $t("CREATED_BY") }} {{ functionBoxCreatedBy }}</small
            >

            <small v-if="delegatedCreatedBy != ''"
              >{{ $t("CREATED_BY") }} {{ delegatedCreatedBy }}</small
            ><div class="mt-2" v-if="isConversation && showRecipients">
              <hr class="pb-0 mb-2 mt-2" />
              <span class="grey" v-if="recipientsNoCreator.length != 0">
                <span
                  v-for="(item, index) in recipientsNoCreator"
                  :key="index + '-recipient'"
                  ><Recipient
                    :index="index"
                    :item="item"
                    :islast="checkLastRecipient(index)"
                  ></Recipient> </span
              ></span>
            </div>
            <div class="mt-2" v-if="!isConversation">
              <div
                v-if="
                  recipientsNoCreator.length != 0 ||
                  participantsNoCreator.length != 0 ||
                  external.length != 0 ||
                  external_system_participants.length != 0
                "
              >
                <hr class="pb-0 mb-2 mt-2" />{{ $t("TO") }}:&nbsp;<span v-if="!isCreator" class="grey"
                  ><span
                    v-for="(item, index) in recipientsNoCreator"
                    :key="index + '-recipient'"
                    ><Recipient
                      :index="index"
                      :functionbox_uuid="functionbox_uuid"
                      :user_uuid="user_uuid"
                      :item="item"
                      :islast="checkLastRecipient(index)"
                    ></Recipient> </span
                ></span><span
                  v-for="(item, index) in participantsNoCreator"
                  :key="index + '-participant'"
                  ><Participant
                    v-if="checkValidVersion('4.3.0')"
                    :response="message.settings.require_response"
                    :message_uuid="message.message_uuid"
                    :index="index"
                    :item="item"
                    :creator="isCreator"
                    :user_uuid="user_uuid"
                    :functionbox_uuid="functionbox_uuid"
                    :islast="checkLastParticipant(index)"
                  ></Participant>
                  <Participant_4_2
                    v-if="!checkValidVersion('4.3.0')"
                    :response="message.settings.require_response"
                    :message_uuid="message.message_uuid"
                    :index="index"
                    :item="item"
                    :creator="isCreator"
                    :user_uuid="user_uuid"
                    :functionbox_uuid="functionbox_uuid"
                    :islast="checkLastParticipant(index)"
                  ></Participant_4_2>
                </span><span
                  v-for="(item, index) in external"
                  :key="index + '-external'"
                  class="ms-fontSize-12"
                >
                  <SecureLink
                  v-if="checkValidVersion('4.3.0')"
                    :message_uuid="message.message_uuid"
                    :response="message.settings.require_response"
                    :index="index"
                    :item="item"
                    :creator="isCreator"
                    :user_uuid="user_uuid"
                    :functionbox_uuid="functionbox_uuid"
                    :islast="external.length - 1 == index"
                  ></SecureLink>
                  <SecureLink_4_2
                  v-if="!checkValidVersion('4.3.0')"
                  :message_uuid="message.message_uuid"
                  :response="message.settings.require_response"
                  :index="index"
                  :item="item"
                  :creator="isCreator"
                  :user_uuid="user_uuid"
                  :functionbox_uuid="functionbox_uuid"
                  :islast="external.length - 1 == index"
                ></SecureLink_4_2>
                </span><span
                  v-for="(item, index) in external_system_participants"
                  :key="index + '-external'"
                  class="ms-fontSize-12"
                >
                  <ExternalParticipant
                    :message_uuid="message.message_uuid"
                    :response="message.settings.require_response"
                    :index="index"
                    :item="item"
                    :creator="isCreator"
                    :user_uuid="user_uuid"
                    :functionbox_uuid="functionbox_uuid"
                    :islast="external_system_participants.length - 1 == index"
                  ></ExternalParticipant>
                </span>
              </div>
            </div>
            <hr class="pb-0 mb-0 mt-2" />
            <RegularMessage
              :message="message"
              :user_uuid="user_uuid"
              :functionbox_uuid="functionbox_uuid"
              v-if="regular_message"
            ></RegularMessage>
            <FaxMessage
              :message="message"
              :user_uuid="user_uuid"
              :functionbox_uuid="functionbox_uuid"
              v-if="message.message_type == 'fax-message'"
            ></FaxMessage>
            <SdkMessage
              :message="message"
              :user_uuid="user_uuid"
              :functionbox_uuid="functionbox_uuid"
              v-if="message.message_type == 'sdk-message'"
            ></SdkMessage>
            <TeamsMeeting
              :message="message"
              :user_uuid="user_uuid"
              :functionbox_uuid="functionbox_uuid"
              v-if="message.message_type == 'teams-meeting'"
            ></TeamsMeeting>
            <NuiteqMeeting
              :message="message"
              :user_uuid="user_uuid"
              :functionbox_uuid="functionbox_uuid"
              v-if="message.message_type == 'nuiteq-meeting'"
            ></NuiteqMeeting>
            <SystemMessage
              :message="message"
              :user_uuid="user_uuid"
              :functionbox_uuid="functionbox_uuid"
              v-if="message.message_type == 'system-message'"
            ></SystemMessage>
            <JitsiMeeting
              :user_uuid="user_uuid"
              :functionbox_uuid="functionbox_uuid"
              :message="message"
              v-if="message.message_type == 'jitsi-meeting'"
            ></JitsiMeeting>
            <JitsiSecureMeeting
              :user_uuid="user_uuid"
              :functionbox_uuid="functionbox_uuid"
              :message="message"
              v-if="message.message_type == 'jitsi-secure-meeting'"
            ></JitsiSecureMeeting>

            <template v-slot:footer>
              <a @click="show = true" class="clickable"
                ><i class="ml-2 fal fa-info-circle"></i> {{ $t("DETAILS") }}</a
              >

              <FunctionBoxAccounts
                v-if="functionbox_uuid"
                :message_uuid="message_uuid"
                :functionbox_uuid="functionbox_uuid"
                :functionbox_accounts="functionbox_accounts"
                ><i class="ml-2 fal fa-info-circle"></i>
                {{ $t("FUNCTIONBOX_USERS") }}</FunctionBoxAccounts
              >

              <a
                @click="showFunctionboxLog = true"
                v-if="functionbox_uuid"
                class="clickable"
                ><i class="ml-2 fal fa-info-circle"></i> {{ $t("LOGG") }}</a
              >

              <DelegatedAccounts
              v-if="delegated_accounts.length != 0"
                :message_uuid="message_uuid"
                :user_uuid="user_uuid"
                :delegated_accounts="delegated_accounts"
                ><i class="ml-2 fal fa-info-circle"></i>
                {{ $t("FUNCTIONBOX_USERS") }}</DelegatedAccounts
              >
              <a
                @click="showDelegatedAccountLog = true"
                v-if="delegated_accounts.length != 0"
                class="clickable"
                ><i class="ml-2 fal fa-info-circle"></i> {{ $t("LOGG") }}</a
              >
            </template>
          </b-card>
        
          <b-sidebar
            id="message-information"
            v-model="show"
            lazy
            right
            no-slide
            shadow
            backdrop
          >
            <div class="px-3 py-2">
              {{ $t("MESSAGE_DETAILS") }}

              <hr class="pb-0 mb-0 mt-2 mb-3" />

              <h6 class="mb-0 no-uppercase">{{ $t("MESSAGE_UUID") }}</h6>
              {{ message.message_uuid }}

              <div v-if="message.creator.name != ''">
                <h6 class="mt-3 mb-0 no-uppercase">{{ $t("CREATOR_UUID") }}</h6>
                {{ message.creator.user_uuid }}
              </div>

              <div v-if="functionbox_uuid">
                <h6 class="mt-3 mb-0 no-uppercase">
                  {{ $t("RECIPIENT") }} {{ $t("FUNCTIONBOX.TITLE") }}
                </h6>
                {{ functionbox_uuid }}
              </div>

              <h6 class="mt-3 mb-0 no-uppercase">
                {{ $t("MESSAGE_VERSION") }}
              </h6>
              {{ message.version }}

              <div v-if="!responseType">
                <h6 class="mt-3 mb-0 no-uppercase">
                  {{ $t("LOA.TITLE_PARTICIPANT") }}
                </h6>
                <i
                  class="fal fa-info-square"
                  v-b-tooltip.hover
                  :title="$t('LOA.INFO.' + message.settings.loa_level)"
                ></i>
                LOA{{ message.settings.loa_level }}
              </div>

              <h6 class="mt-3 mb-0 no-uppercase">{{ $t("TYPE") }}</h6>
              {{ $t("MESSAGES.TYPE." + message.message_type) }}

              <h6 class="mt-3 mb-0 no-uppercase" v-if="!responseType">
                {{ $t("RESPONSE") }}
              </h6>
              <span v-if="!responseType">{{
                $t("MESSAGES.REQUESTED_RESPONSE")
              }}</span>

              <hr class="pb-0 mb-0 mt-2" />
            </div>
          </b-sidebar>

          <b-sidebar
            id="message-eventlog"
            v-model="showFunctionboxLog"
            lazy
            right
            no-slide
            shadow
            backdrop
          >
            <div class="px-3 py-2">
              {{ $t("LOGG") }}

              <hr class="pb-0 mb-0 mt-2 mb-3" />
              <EventLog
                :message_uuid="message_uuid"
                type="message-functionbox"
                :functionbox_uuid="functionbox_uuid"
                v-if="functionbox_uuid"
              ></EventLog>
            </div>
          </b-sidebar>

          <b-sidebar
            id="message-eventlog-useruuid"
            v-model="showDelegatedAccountLog"
            lazy
            right
            no-slide
            shadow
            backdrop
          >
            <div class="px-3 py-2">
              {{ $t("LOGG") }}

              <hr class="pb-0 mb-0 mt-2 mb-3" />
              <EventLog
                :message_uuid="message_uuid"
                type="message-delegated-account"
                :user_uuid="user_uuid"
                v-if="user_uuid"
              ></EventLog>
            </div>
          </b-sidebar>
        </div>
        <iframe name="print_frame" width="0" height="0" frameborder="0" src="about:blank"></iframe>

        <div v-if="showOldMessages">
          <div class="text-center mb-2">
            <b-button
              class="no-border"
              v-if="responses_before > 0"
              @click="showConversation"
            >
              <i class="fal fa-chevron-double-down"></i> &nbsp;
              {{ responses_before }} {{ $t("CONVERSATION_OLDER_MESSAGES") }}
            </b-button>
          </div>
        </div>
      </div>
      <div v-if="error">
        <b-button
          v-if="showCloseBtn"
          @click="closeMessage"
          class="no-border"
          v-b-tooltip.hover
          :title="$t('CLOSE')"
        >
          <i class="fal fa-times"></i
          ><span class="hidden-mobile">&nbsp;{{ $t("CLOSE") }}</span>
        </b-button>
        <b-button
          @click="getInformation"
          class="no-border"
          v-if="!isConversation"
        >
          <i class="fal fa-sync"></i
          ><span class="hidden-mobile">&nbsp;{{ $t("UPDATE") }}</span>
        </b-button>
        <b-button
          @click="removeMessage"
          class="no-border"
          v-if="!isConversation && (errorMessage != 'ERROR.RECALLED')"
        >
          <i class="fal fa-sync"></i
          ><span class="hidden-mobile">&nbsp;{{ $t("REMOVE") }}</span>
        </b-button>
        <b-card class="card-message text-center">
          <template v-slot:header> &nbsp; </template>
          <div class="mt-2 mb-2">
            <i class="fal fa-exclamation-circle"></i>
            {{ $t(errorMessage) }}
          </div>
        </b-card>
      </div>
    </b-overlay>
    <LoaLevel :loa_level="loa_error" v-if="!isConversation"></LoaLevel>
  </section>
</template>
<script>
import AddMessageForward from "@/components/Compose/AddMessageForward";
import AddMessageReply from "@/components/Compose/AddMessageReply";
import DelegatedAccounts from "@/components/View/DelegatedAccounts";
import EventLog from "@/components/EventLog.vue";
import FunctionBoxAccounts from "@/components/View/FunctionBoxAccounts";
import RegularMessage from "@/components/View/Information/RegularMessage";
import NuiteqMeeting from "@/components/View/Information/NuiteqMeeting";
import SystemMessage from "@/components/View/Information/SystemMessage";
import JitsiMeeting from "@/components/View/Information/JitsiMeeting";
import JitsiSecureMeeting from "@/components/View/Information/JitsiSecureMeeting";
import TeamsMeeting from "@/components/View/Information/TeamsMeeting";
import SdkMessage from "@/components/View/Information/SdkMessage";
import FaxMessage from "@/components/View/Information/FaxMessage";
import UserInfo from "@/components/Layout/UserInfo";
import Recipient from "@/components/View/Recipient";
import Participant from "@/components/View/Participant";
import Participant_4_2 from "@/components/View/Participant_4_2";
import ExternalParticipant from "@/components/View/ExternalParticipant";
import SecureLink from "@/components/View/SecureLink";
import SecureLink_4_2 from "@/components/View/SecureLink_4_2";
import LoaLevel from "@/components/View/LoaLevel";
export default {
  name: "MessageInformation",
  props: {
    message_uuid: {
      default: "",
      type: String,
    },
    functionbox_uuid: {
      default: "",
      type: String,
    },
    user_uuid: {
      default: "",
      type: String,
    },
    showCloseBtn: {
      type: Boolean,
      validator(value) {
        return value != undefined;
      },
    },
    isConversation: {
      type: Boolean,
      validator(value) {
        return value != undefined;
      },
    },
  },
  components: {
    AddMessageForward,
    AddMessageReply,
    EventLog,
    DelegatedAccounts,
    RegularMessage,
    TeamsMeeting,
    SdkMessage,
    LoaLevel,
    UserInfo,
    Participant,
    Participant_4_2,
    SecureLink,
    SecureLink_4_2,
    JitsiMeeting,
    JitsiSecureMeeting,
    FunctionBoxAccounts,
    ExternalParticipant,
    Recipient,
    NuiteqMeeting,
    FaxMessage,
    SystemMessage,
  },
  data() {
    return {
      response_to_message_uuid: "",
      last_response_uuid: "",
      responses_after: 0,
      responses_before: 0,
      showAddConversation: false,
      conversation_uuid: "",
      showAllResponse: false,
      loa_error: 0,
      show: false,
      showFunctionboxLog: false,
      showDelegatedAccountLog: false,
      opened: false,
      error: false,
      loading: true,
      email: "",
      participants: [],
      external_status: [],
      external_system_participants: [],
      errorMessage: "",
      message: {},
      external: [],
      functionbox_accounts: [],
      delegated_accounts: [],
    };
  },
  methods: {
  testBtn()
  {
    
  },
    gotoMessage() {
      this.$emit("gotoMessage", this.message.message_uuid);
    },
    sentMessage() {
      this.getInformation();
      this.getBeforeAfter();
    },
    showConversation() {
      this.$emit("showConversation", this.message.message_uuid);
    },
    createdResponse() {
      this.showAddConversation = false;
      this.getInformation();
    },
    cancelReply() {
      this.showAddConversation = false;
    },
    printBtn() {
      /*if(this.microsoftTeams.teamsCore.isSupported())
      {
        this.microsoftTeams.teamsCore.print();
      }else{*/
        //window.print();
      //}
      let start = '<html><head><meta http-equiv=cache-control content="max-age=0"><meta http-equiv=cache-control content=no-cache><meta http-equiv=expires content=0><meta http-equiv=expires content="Tue, 01 Jan 1980 1:00:00 GMT"><meta http-equiv=pragma content=no-cache><meta charset=utf-8><meta http-equiv=X-UA-Compatible content="IE=edge"><meta name=viewport content="width=device-width,initial-scale=1"><title>SEFOS</title><link type=text/css rel=stylesheet href=/css/bootstrap.min.css><link rel=apple-touch-icon sizes=180x180 href=/favicon/apple-touch-icon.png><link rel=icon type=image/png sizes=32x32 href=/favicon/favicon-32x32.png><link rel=icon type=image/png sizes=16x16 href=/favicon/favicon-16x16.png><link rel=manifest href=/favicon/site.webmanifest><link rel=stylesheet href=/css/animate.min.css></head><body>';
      start = start.replaceAll("/css/",process.env.VUE_APP_URL + "/css/");
      var content = document.getElementById("printMe").innerHTML;
      content = content.replace(/(<(pre|script|style|textarea|div)[^]+?<\/\2)|(^|>)\s+|\s+(?=<|$)/g, "$1$3");
      content = content.replaceAll("\n","<br>");      
      window.frames["print_frame"].document.body.innerHTML =  start + content + '</body></html>';
      //console.log(start + content + '</body></html>');
      window.frames["print_frame"].window.focus();
      setTimeout(function() { window.frames["print_frame"].window.print(); }, 500);
    },
    removeMessage() {
      let self = this;
      const h = this.$createElement;
      let messageVNode = h("p", { class: ["mb-0 pb-0"] }, [
        h(
          "p",
          { class: ["text-center mb-0 pb-0"] },
          self.$t("CONFIRM.DO_YOU_WANT_TO_REMOVE", {
            msg: self.$t("MESSAGES.TYPE." + self.message.message_type),
          })
        ),
      ]);
      if (this.isCreator) {
        messageVNode = h("p", { class: ["mb-0 pb-0"] }, [
          h(
            "p",
            { class: ["text-center mb-0 pb-0"] },
            self.$t("CONFIRM.DO_YOU_WANT_TO_REMOVE_CREATOR", {
              msg: self.$t("MESSAGES.TYPE." + self.message.message_type),
            })
          ),
        ]);
      }
      this.$bvModal
        .msgBoxConfirm([messageVNode], {
          size: "md",
          buttonSize: "sm",
          okVariant: "primary",
          okTitle: this.$t("YES"),
          cancelTitle: this.$t("NO"),
          dialogClass: this.teams.theme,
          bodyClass: "messagebox",
          footerClass: "p-2  text-center messagebox",
          hideHeaderClose: false,
          centered: true,
        })
        .then(function (value) {
          if (value) {
            self.$http
              .post(self.user.hostname + "/message/remove", {
                message_uuid: self.message_uuid,
                user_uuid: self.user_uuid,
                functionbox_uuid: self.functionbox_uuid,
              })
              .then(() => {
                self.$emit("closeMessage");
              })
              .catch(function (error) {
                if(error.toString() == "Error: fail_4_4") return;
                self.$noty.error(self.$t("ERROR.COULD_NOT_SAVE"));
              });
          }
        })
        .catch(function () {});
    },
    closeMessage: function () {
      this.$emit("closeMessage");
    },
    getBeforeAfter: function () {
      let self = this;
      this.$http
        .post(this.user.hostname + "/message/conversation/before-after", {
          message_uuid: this.message_uuid,
          functionbox_uuid: this.functionbox_uuid,
          user_uuid: this.user_uuid,
          page: 1,
          limit: 1,
        })
        .then((response) => {
          self.responses_after = response.data.after;
          self.responses_before = response.data.before;
        })
        .catch(() => {});
    },
    claim: function () {
      let self = this;
      this.$http
        .post(this.user.hostname + "/message/functionbox/claim", {
          message_uuid: this.message_uuid,
          functionbox_uuid: this.functionbox_uuid,
        })
        .then(() => {
          self.getInformation();
        })
        .catch(() => {});
    },
    noClaim: function () {
      let self = this;
      this.$http
        .post(this.user.hostname + "/message/functionbox/claim/remove", {
          message_uuid: this.message_uuid,
          functionbox_uuid: this.functionbox_uuid,
        })
        .then(() => {
          self.getInformation();
        })
        .catch(() => {});
    },
    closeIssue(){
      let self = this;
      this.$http
          .post(this.user.hostname + "/message/functionbox/archive", {
            message_uuid: this.message_uuid,
            functionbox_uuid: this.functionbox_uuid,
          })
          .then(() => {
            self.getInformation();
          })
          .catch(() => {});
    },
    archiveOld()
    {

    },
    archive: function () {
      let self = this;
      if(this.checkValidVersion('4.2.0'))
      {
        const h = this.$createElement;
        let messageVNode = h("p", { class: ["mb-0 pb-0"] }, [
          h(
            "p",
            { class: ["text-center mb-0 pb-0"] },
            self.$t("CONFIRM.DO_YOU_WANT_TO_CLOSE", {
              msg: self.$t("MESSAGES.TYPE." + self.message.message_type),
            })
          ),
        ]);
        this.$bvModal
          .msgBoxConfirm([messageVNode], {
            size: "md",
            buttonSize: "sm",
            okVariant: "primary",
            okTitle: this.$t("YES"),
            cancelTitle: this.$t("NO"),
            dialogClass: this.teams.theme,
            bodyClass: "messagebox",
            footerClass: "p-2  text-center messagebox",
            hideHeaderClose: false,
            centered: true,
          })
          .then(function (value) {
            if (value) {            
              self.$http
                .post(self.user.hostname + "/message/user/archive", {
                  message_uuid: self.message_uuid,
                  user_uuid: self.user_uuid,
                })
                .then(() => {
                  self.getInformation();
                })
                .catch(() => {});
            }
          })
          .catch(function () {});      
      }else{
        self.$http
                .post(self.user.hostname + "/message/user/archive", {
                  message_uuid: self.message_uuid,
                  user_uuid: self.user_uuid,
                })
                .then(() => {
                  self.getInformation();
                })
                .catch(() => {});
      }
    },
    noArchive: function () {
      let self = this;
      if (this.functionbox_uuid != "") {
        this.$http
          .post(this.user.hostname + "/message/functionbox/archive/remove", {
            message_uuid: this.message_uuid,
            functionbox_uuid: this.functionbox_uuid,
          })
          .then(() => {
            self.getInformation();
          })
          .catch(() => {});
      } else {
        this.$http
          .post(this.user.hostname + "/message/user/archive/remove", {
            message_uuid: this.message_uuid,
            user_uuid: this.user_uuid,
          })
          .then(() => {
            self.getInformation();
          })
          .catch(() => {});
      }
    },
    bytesToSize(bytes, decimals = 2) {
      if (bytes === 0) return "0";
      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    },
    checkLastParticipant(index) {
      if (this.external.length != 0) {
        return false;
      } else {
        return this.participantsNoCreator.length - 1 == index;
      }
    },
    checkLastRecipient(index) {
      if (this.message.recipients == undefined) {
        return true;
      }
      if (this.message.recipients.length == 0) {
        return false;
      } else {
        return this.recipientsNoCreator.length - 1 == index;
      }
    },
    async updateUser() {
      await this.$store.dispatch("user/fetchUser");
    },
    getInformation: function () {
      let self = this;
      this.loa_error = 0;
      this.error = false;
      this.opened = false;
      this.$http
        .post(this.user.hostname + "/message/uuid/open", {
          message_uuid: this.message_uuid,
          functionbox_uuid: this.functionbox_uuid,
          user_uuid: this.user_uuid,
        })
        .then((response) => {
          self.conversation_uuid = response.data.conversation_uuid;
          self.message = response.data.message;
          self.participants = response.data.participants;
          self.external_system_participants = response.data.external_system_participant;
          self.external = response.data.external;
          self.functionbox_accounts = response.data.functionbox_accounts;
          self.delegated_accounts = response.data.delegated_accounts;
          self.opened = true;
          self.loading = false;
          self.$emit("closeConversation");
          self.response_to_message_uuid = self.message.message_uuid;
          if (self.message.response_to_message != "") {
            self.response_to_message_uuid = self.message.response_to_message;
          }
          self.updateUser();
          if (!self.isConversation) {
            self.getBeforeAfter();
          }
        })
        .catch((error) => {
          self.loading = false;
          self.opened = false;
          self.error = true;
          if (error.response.data != undefined) {
            if (
              error.response.data == "ERROR.LOA_LOW3" ||
              error.response.data == "ERROR.LOA_LOW2"
            ) {
              self.loa_error = parseInt(error.response.data.slice(-1));
            }
            self.errorMessage = error.response.data;
          }
        });
    },
  },
  computed: {
    showNewMessages() {
      if (this.isConversation) {
        return false;
      }
      if (this.responses_after == 0) {
        return false;
      }
      return true;
    },
    showOldMessages() {
      if (this.isConversation) {
        return false;
      }
      if (this.responses_before == 0) {
        return false;
      }
      return true;
    },
    iconImage() {
      return "/img/message_type/" + this.message.message_type + ".png";
    },
    showArchived() {
      let self = this;
      if (self.isCreator) {
        console.log("ISCREATOR");
        console.log(this.$const.MessageStatus);
        return self.message.status == this.$const.MessageStatus.ARCHIVED;
      } else {
        if (self.functionbox_uuid != "") {
          let me = self.participants.filter(
            (c) => c.user_uuid == self.functionbox_uuid
          );
          if (me.length > 0) {
            return me[0].archived == 1;
          } else {
            return false;
          }
        } else {
          if (self.user_uuid != "") {
            let me = self.participants.filter(
              (c) => c.user_uuid == self.user_uuid
            );
            return me[0].archived == 1;
          } else {
            let me = self.participants.filter(
              (c) => c.user_uuid == self.user.information.user_uuid
            );
            return me[0].archived == 1;
          }
        }
      }
    },
    direktLink() {
      if (this.functionbox_uuid != "") {
        return (
          this.user.hostname.replace("/server/rest","") + "/message/" +
          this.message.message_uuid +
          "/f/" +
          this.functionbox_uuid
        );
      } else {
        if (this.user_uuid != "") {
          return this.user.hostname.replace("/server/rest","") + (
            "/message/" + this.message.message_uuid + "/u/" + this.user_uuid
          );
        } else {
          return this.user.hostname.replace("/server/rest","") + "/message/" + this.message.message_uuid;
        }
      }
    },
    isResponse() {
      if(this.message.message_type == "system-message")
      {
        return false;
      }else{
        if (
          this.message.message_type == "response" ||
          this.message.message_type == "link-response"
        ) {
          return true;
        } else {
          return false;
        }
      }
    },
    regular_message() {
      if (
        this.message.message_type == "message" ||
        this.message.message_type == "response" ||
        this.message.message_type == "creator-response" ||
        this.message.message_type == "link-response" ||
        this.message.message_type == "creator-link-response"
      ) {
        return true;
      } else {
        return false;
      }
    },
    responseType() {
      return (
        this.message.message_type == "response" ||
        this.message.message_type == "link-response"
      );
    },
    createdTime() {
      return this.FormatDateTime(this.message.created_date);
    },
    createdName() {
      if (this.message.creator.name == "") {
        return this.message.creator.email;
      } else {
        if (this.$const.reg_phone.test(this.message.creator.name)) {
          return this.message.creator.name;
        } else {
          return (
            this.message.creator.name +
            ", " +
            this.message.creator.organisation_name
          );
        }
      }
    },
    isCreator() {
      if (this.functionbox_uuid != "") {
        if (this.message.creator != undefined) {
          return this.message.creator.user_uuid == this.functionbox_uuid;
        } else {
          return false;
        }
      } else {
        if (this.user_uuid != "") {
          if (this.message.creator != undefined) {
            return this.message.creator.user_uuid == this.user_uuid;
          } else {
            return false;
          }
        } else {
          if (this.message.creator != undefined) {
            return (
              this.message.creator.user_uuid == this.user.information.user_uuid
            );
          } else {
            return false;
          }
        }
      }
    },
    userIsCreator() {
      return this.user.information.user_uuid == this.message.creator.user_uuid;
    },
    functionBoxIsCreator() {
      return this.functionbox_uuid == this.message.creator.user_uuid;
    },
    DelegatedBoxIsCreator() {
      return this.user_uuid == this.message.creator.user_uuid;
    },
    participantsNoCreator() {
      if (this.functionbox_uuid != "") {
        return this.participants.filter(
          (c) => c.user_uuid != this.functionbox_uuid
        );
      } else {
        if (this.user_uuid != "") {
          return this.participants.filter((c) => c.user_uuid != this.user_uuid);
        } else {
          return this.participants.filter(
            (c) => c.email != this.user.information.email
          );
        }
      }
    },
    showRecipients() {
      if(this.message.message_type == "system-message")
      {
        return false;
      }else{
        if (this.message.message_type == "fax-message") {
          return false;
        }
        if (this.message.message_type == "sdk-message") {
          return false;
        }
        return true;
      }
    },
    recipientsNoCreator() {
      let self = this;
      return this.message.recipients.filter(
        (c) => c.email != self.message.creator.email
      );
    },
    functionBoxCreatedBy() {
      let me = this.functionbox_accounts.filter((c) => c.creator == 1);
      if (me.length != 0) {
        return me[0].email;
      }
      return "";
    },
    delegatedCreatedBy() {
      let me = this.delegated_accounts.filter((c) => c.creator == 1);
      if (me.length != 0) {
        return me[0].email;
      }
      return "";
    },
    claimedBy() {
      if (this.showArchived) {
        return null;
      }
      if (this.isCreator) {
        return null;
      }
      let claimedList = this.functionbox_accounts.filter(function (item) {
        return item.claimed == 1;
      });
      if (claimedList.length != 0) {
        return claimedList[0];
      } else {
        return null;
      }
    },
    haveIClaimed() {
      if (this.claimedBy != null) {
        if (this.message.creator.user_uuid == this.functionbox_uuid) {
          return false;
        } else {
          return this.claimedBy.email == this.user.information.email;
        }
      } else {
        return false;
      }
    },
    showRemoveClaim() {
      if (this.functionbox_uuid != "") {
        if (this.message.creator.user_uuid == this.functionbox_uuid) {
          return false;
        } else {
          return this.haveIClaimed;
        }
      } else {
        return false;
      }
    },
    showClaim() {
      if (this.functionbox_uuid != "") {
        if (this.claimedBy == null) {
          if (this.message.creator.user_uuid != this.functionbox_uuid) {
            return true;
          } else {
            return false;
          }
        } else {
          if(this.checkValidVersion('4.2.0')){
            if(this.claimedBy.email != this.user.information.email)
            {
              return true;
            }else{
              return false;
            }
          }else{
            return false;
          }
        }
      } else {
        return false;
      }
    },
    canRemove() {
      if(!this.IsMessage(this.message.message_type))
      {
        return true;
      }else{
        if (this.user.information.organisation.users_can_remove == 0) {
          return false;
        } else {
          if (this.functionbox_uuid != "") {
            if (this.showClaim) {
              return true;
            } else {
              if (this.haveIClaimed) {
                return true;
              } else {
                if (this.isCreator) {
                  return true;
                } else {
                  return false;
                }
              }
            }
          } else {
            return true;
          }
        }
      }
    },    
    showRespond() {
      if(this.message.message_type == "system-message")
      {
        return false;
      }else{
        if (this.message.message_type == "fax-message") {
          return !this.isCreator;
        }
        return (
          !this.isConversation &&
          !this.isCreator &&
          this.message.conversation_uuid != ""
        );
      }
    },
    showComplete() {
      if(this.IsMeeting(this.message.message_type))
      {
        return false;
      }
      if(this.message.message_type == "system-message")
      {
        return false;
      }
      if (this.message.message_type == "fax-message") {
        return this.isCreator;
      }
      return (
        !this.isConversation &&
        this.isCreator &&
        this.message.conversation_uuid != ""
      );
    },
    showRespondAll() {
      if(!this.IsSefosMessage(this.message.message_type))
      {
        return !this.isCreator;
      }else{
        return (
          !this.isConversation &&
          !this.isCreator &&
          this.message.conversation_uuid != ""
        );
      }
    },
    showForward() {
      if(this.message.message_type == "system-message")
      {
        return false;
      }else{
        if(this.IsMessage(this.message.message_type))
        {
          return !this.isConversation;
        }else{
          return false;
        }
      }
    }
  },
  watch: {
    message_uuid: function (val, oldval) {
      if (val != oldval) {
        this.getInformation();
      }
    },
  },
  mounted: function () {
    this.getInformation();
  },
};
</script>
<style></style>